(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.querySelectorAll('.rw-article-page').forEach(page => {
    if (page.dataset.articleInitialized) return;
    page.dataset.articleInitialized = 'true';
    const content = page.querySelector('.rw-article-content');
    const contents = page.querySelector('.rw-article-contents');
    const headings = [...content.querySelectorAll('h2, h3')].filter(heading => heading.textContent.trim());
    if (headings.length > 1) {
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = content.id + '-heading-' + index;
        const link = document.createElement('a'); link.href = '#' + heading.id; link.textContent = heading.textContent;
        link.dataset.level = heading.tagName.slice(1);
        contents.querySelector('nav').append(link);
      });
      if (matchMedia('(max-width: 800px)').matches) contents.querySelector('details').open = false;
      contents.hidden = false;
    }
    const share = page.querySelector('[data-share-title]');
    if (navigator.share || navigator.clipboard) {
      share.hidden = false;
      share.addEventListener('click', async () => {
        const url = new URL(location.href); url.searchParams.delete('preview_theme_id');
        try {
          if (navigator.share) await navigator.share({ title: share.dataset.shareTitle, url: url.href });
          else { await navigator.clipboard.writeText(url.href); share.querySelector('span:last-child').textContent = share.dataset.copied; }
        } catch (error) { if (error.name !== 'AbortError') share.querySelector('span:last-child').textContent = share.dataset.shareTitle; }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!window.rwCollectionStockInitialized) {
    window.rwCollectionStockInitialized = true;
    document.addEventListener('change', event => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.matches('[data-rw-in-stock]')) return;
      if (input.form) input.form.requestSubmit();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!window.rwHeaderNavigationInitialized) {
    window.rwHeaderNavigationInitialized = true;
    const closeHeader = header => {
      header.querySelectorAll('.rw-nav-dropdown[open], .rw-mobile-menu[open], rw-country-selector > details[open]').forEach(menu => { menu.open = false; });
    };
    document.addEventListener('toggle', event => {
      const menu = event.target;
      if (!(menu instanceof HTMLDetailsElement)) return;
      if (menu.matches('.rw-nav-dropdown') && menu.open) {
        menu.closest('.rw-header').querySelectorAll('.rw-nav-dropdown[open]').forEach(other => {
          if (other !== menu) other.open = false;
        });
        menu.closest('.rw-header').querySelectorAll('rw-country-selector > details[open]').forEach(other => { other.open = false; });
      }
      if (menu.matches('rw-country-selector > details') && menu.open) {
        menu.closest('.rw-header')?.querySelectorAll('.rw-nav-dropdown[open]').forEach(other => { other.open = false; });
      }
      if (menu.matches('.rw-mobile-menu') && !menu.open) {
        menu.querySelectorAll('.rw-nav-dropdown[open], rw-country-selector > details[open]').forEach(child => { child.open = false; });
      }
    }, true);
    document.addEventListener('click', event => {
      document.querySelectorAll('.rw-header').forEach(header => {
        if (!header.contains(event.target)) closeHeader(header);
        else if (event.target.closest('a[href]')) closeHeader(header);
      });
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const header = event.target.closest('.rw-header');
      if (!header) return;
      const openMenu = header.querySelector('.rw-nav-dropdown[open]') || header.querySelector('.rw-mobile-menu[open]');
      if (openMenu) {
        event.preventDefault();
        openMenu.open = false;
        openMenu.querySelector('summary').focus();
      }
    });
    document.addEventListener('focusout', event => {
      const header = event.target.closest('.rw-header');
      if (header && event.relatedTarget && !header.contains(event.relatedTarget)) closeHeader(header);
    });
    window.matchMedia('(max-width: 900px)').addEventListener('change', () => {
      document.querySelectorAll('.rw-header').forEach(closeHeader);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('rw-product')) customElements.define('rw-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const select = this.querySelector('[name="id"]');
      const quantity = this.querySelector('[name="quantity"]');
      const add = this.querySelector('[data-add]');
      const showImage = id => {
        if (!id || !this.querySelector('[data-image-id="' + id + '"]')) return;
        this.querySelectorAll('[data-image-id]').forEach(image => { image.hidden = image.dataset.imageId !== id; });
        this.querySelectorAll('[data-image-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.imageTarget === id)));
      };
      this.querySelectorAll('[data-image-target]').forEach(button => button.addEventListener('click', () => showImage(button.dataset.imageTarget)));
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        this.querySelectorAll('[data-variant-price]').forEach(price => { price.hidden = price.dataset.variantPrice !== select.value; });
        add.disabled = option.dataset.available !== 'true';
        const status = this.querySelector('[data-stock-status]');
        const stockLabel = status?.querySelector('[data-stock-label]');
        const dispatch = this.querySelector('[data-dispatch-message]');
        if (status) status.dataset.stockState = option.dataset.stockState;
        if (stockLabel) stockLabel.textContent = option.dataset.stockLabel;
        if (dispatch) dispatch.hidden = add.disabled || option.dataset.stockState === 'on_order';
        if (status) status.hidden = !stockLabel && (!dispatch || dispatch.hidden);
        add.querySelector('span:last-child').textContent = add.disabled ? add.dataset.soldLabel : add.dataset.addLabel;
        quantity.value = option.dataset.min || '1';
        showImage(option.dataset.image);
        const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-pace-calculator')) customElements.define('rw-pace-calculator', class extends HTMLElement {
    static selection(search, hash, initialMode = 'pace') {
      const modes = ['pace', 'time', 'distance', 'speed'];
      const params = new URLSearchParams(search);
      const hashMode = hash.replace(/^#find-/, '');
      const mode = modes.includes(params.get('mode')) ? params.get('mode') : modes.includes(hashMode) ? hashMode : modes.includes(initialMode) ? initialMode : 'pace';
      const unit = params.get('unit');
      const paceUnit = params.get('pace_unit') || (['km', 'mile'].includes(unit) ? unit : 'km');
      const speedUnit = params.get('speed_unit') || (['kmh', 'mph'].includes(unit) ? unit : 'kmh');
      const result = { mode, paceUnit: ['km', 'mile'].includes(paceUnit) ? paceUnit : 'km', speedUnit: ['kmh', 'mph'].includes(speedUnit) ? speedUnit : 'kmh', inputKind: 'pace' };
      if (params.has('speed') || params.has('speed_unit') || ['kmh', 'mph'].includes(unit)) result.inputKind = 'speed';
      const rawPace = params.get('pace');
      if (rawPace !== null && /^(?:\d+(?:\.\d+)?|\d+:\d{2})$/.test(rawPace)) {
        const parts = rawPace.split(':');
        const seconds = parts.length === 2 ? Number(parts[0]) * 60 + Number(parts[1]) : Number(rawPace);
        const rounded = Math.round(seconds);
        if (rounded >= 1 && rounded <= 59999 && (parts.length === 1 || Number(parts[1]) < 60)) result.pace = rounded;
      }
      const rawSpeed = params.get('speed');
      if (rawSpeed !== null && /^\d+(?:\.\d+)?$/.test(rawSpeed)) {
        const speed = Number(rawSpeed);
        if (Number.isFinite(speed) && speed >= 0.001 && speed <= 10000) result.speed = speed;
      }
      return result;
    }
    static fieldNames = ['distance', 'unit', 'hours', 'minutes', 'seconds', 'pace_minutes', 'pace_seconds', 'pace_unit', 'speed', 'speed_unit', 'input_kind', 'pace_output_unit', 'speed_output_unit'];
    static fieldState(search) {
      const params = new URLSearchParams(search);
      const result = {};
      const limits = { distance: [0.001, 10000], hours: [0, 999, true], minutes: [0, 59, true], seconds: [0, 59, true], pace_minutes: [0, 999, true], pace_seconds: [0, 59, true], speed: [0.001, 10000] };
      for (const [name, [minimum, maximum, integer]] of Object.entries(limits)) {
        const raw = params.get(name);
        if (raw === null || !/^\d+(?:\.\d+)?$/.test(raw)) continue;
        const value = Number(raw);
        if (Number.isFinite(value) && value >= minimum && value <= maximum && (!integer || Number.isInteger(value))) result[name] = value;
      }
      const units = { unit: ['km', 'mile'], pace_unit: ['km', 'mile'], pace_output_unit: ['km', 'mile'], speed_unit: ['kmh', 'mph'], speed_output_unit: ['kmh', 'mph'], input_kind: ['pace', 'speed'] };
      for (const [name, values] of Object.entries(units)) if (values.includes(params.get(name))) result[name] = params.get(name);
      return result;
    }
    static visibleInputs(mode, inputKind) {
      const rate = mode === 'time' || mode === 'distance';
      return { distance: mode !== 'distance', time: mode !== 'time', rate, pace: rate && inputKind === 'pace', speed: rate && inputKind === 'speed', 'pace-output': mode === 'pace', 'speed-output': mode === 'speed' };
    }
    async connectedCallback() {
      if (this.ready) { window.addEventListener('hashchange', this.onHashChange); return; }
      await customElements.whenDefined('rw-pace-engine');
      if (!this.isConnected || this.ready) return;
      this.math = customElements.get('rw-pace-engine').math;
      this.ready = true;
      this.form = this.querySelector('form');
      this.tabs = [...this.querySelectorAll('[data-mode]')];
      this.routes = JSON.parse(this.querySelector('[data-calculator-routes]').textContent);
      this.families = JSON.parse(this.querySelector('[data-calculator-families]').textContent);
      this.form.addEventListener('input', () => this.syncCalculatorLinks());
      this.querySelectorAll('[data-distance]').forEach(button => button.addEventListener('click', () => {
        this.form.elements.unit.value = 'km'; this.form.elements.distance.value = button.dataset.distance; this.compute();
      }));
      this.form.addEventListener('submit', event => { event.preventDefault(); this.compute(); });
      this.form.addEventListener('change', event => {
        if (event.target.name === 'input_kind') this.select(this.mode);
        else if (['unit', 'pace_unit', 'speed_unit', 'pace_output_unit', 'speed_output_unit'].includes(event.target.name)) this.compute();
        this.syncCalculatorLinks();
      });
      this.form.addEventListener('reset', () => { requestAnimationFrame(() => { this.select(this.dataset.initialMode || 'pace'); }); });
      const selected = this.constructor.selection(location.search, location.hash, this.dataset.initialMode);
      this.form.elements.pace_unit.value = selected.paceUnit;
      this.form.elements.pace_output_unit.value = selected.paceUnit;
      this.form.elements.speed_unit.value = selected.speedUnit;
      this.form.elements.speed_output_unit.value = selected.speedUnit;
      this.form.elements.input_kind.value = selected.inputKind;
      if (selected.pace !== undefined) {
        this.form.elements.pace_minutes.value = Math.floor(selected.pace / 60);
        this.form.elements.pace_seconds.value = selected.pace % 60;
      }
      if (selected.speed !== undefined) this.form.elements.speed.value = selected.speed;
      const retained = this.constructor.fieldState(location.search);
      for (const [name, value] of Object.entries(retained)) this.form.elements[name].value = value;
      if ((selected.mode === 'pace' || selected.mode === 'speed') && !['hours', 'minutes', 'seconds'].some(name => Object.hasOwn(retained, name))) {
        const perKm = selected.speed !== undefined ? this.math.speedToPace(selected.speed, selected.speedUnit)
          : selected.pace !== undefined ? selected.pace / (selected.paceUnit === 'mile' ? this.math.mile : 1) : null;
        if (perKm !== null) {
          const km = Number(this.form.elements.distance.value) * (this.form.elements.unit.value === 'mile' ? this.math.mile : 1);
          const seconds = this.math.roundSeconds(km * perKm);
          if (seconds > 0 && seconds <= 3599999) {
            this.form.elements.hours.value = Math.floor(seconds / 3600);
            this.form.elements.minutes.value = Math.floor(seconds / 60) % 60;
            this.form.elements.seconds.value = seconds % 60;
          }
        }
      }
      this.select(selected.mode);
      this.onHashChange = () => {
        const mode = location.hash.replace(/^#find-/, '');
        if (['pace', 'time', 'distance', 'speed'].includes(mode) && mode !== this.mode) this.navigate(mode);
      };
      window.addEventListener('hashchange', this.onHashChange);
      if (selected.mode !== (this.dataset.initialMode || 'pace')) this.navigate(selected.mode);
    }
    disconnectedCallback() { window.removeEventListener('hashchange', this.onHashChange); }
    select(mode) {
      if (!['pace', 'time', 'distance', 'speed'].includes(mode)) mode = 'pace';
      this.mode = mode;
      this.tabs.forEach(tab => { if (tab.dataset.mode === mode) tab.setAttribute('aria-current', 'page'); else tab.removeAttribute('aria-current'); });
      const visible = this.constructor.visibleInputs(mode, this.form.elements.input_kind.value);
      this.querySelectorAll('[data-input]').forEach(group => {
        group.hidden = !visible[group.dataset.input];
        group.querySelectorAll('input, select').forEach(input => { input.disabled = group.hidden; });
        if (group.tagName === 'FIELDSET') group.disabled = group.hidden;
      });
      this.querySelector('[data-error-output]').hidden = true;
      this.syncPaceLinks();
      this.compute();
      this.syncCalculatorLinks();
    }
    navigate(mode) {
      const destination = this.tabs.find(tab => tab.dataset.mode === mode);
      if (destination) { this.syncCalculatorLinks(); location.replace(destination.href); }
    }
    syncCalculatorLinks() {
      const fields = this.form.elements;
      const params = new URLSearchParams();
      for (const name of this.constructor.fieldNames) params.set(name, fields[name].value);
      const state = this.constructor.fieldState(params);
      try {
        const inputRate = this.mode === 'time' || this.mode === 'distance';
        const speedInput = inputRate && fields.input_kind.value === 'speed';
        const time = this.mode === 'time' ? 0 : this.number('hours') * 3600 + this.number('minutes') * 60 + this.number('seconds');
        const pace = inputRate && !speedInput ? this.number('pace_minutes') * 60 + this.number('pace_seconds') : 0;
        const options = speedInput ? { inputKind: 'speed', speed: this.number('speed'), speedUnit: fields.speed_unit.value } : undefined;
        const result = this.math.calculate(this.mode, this.mode === 'distance' ? 0 : this.number('distance'), fields.unit.value, this.mode === 'time' ? 0 : time, inputRate && !speedInput ? pace : 0, fields.pace_unit.value, options);
        if (this.mode === 'time') {
          const seconds = this.math.roundSeconds(result.time);
          if (seconds <= 3599999) { state.hours = Math.floor(seconds / 3600); state.minutes = Math.floor(seconds / 60) % 60; state.seconds = seconds % 60; }
        }
        if (this.mode === 'distance') state.distance = Number((result.km / (fields.unit.value === 'mile' ? this.math.mile : 1)).toFixed(6));
        if (!inputRate) {
          state.input_kind = this.mode === 'speed' ? 'speed' : 'pace';
          state.pace_unit = fields.pace_output_unit.value;
          state.speed_unit = fields.speed_output_unit.value;
          const row = this.math.row(result.pace);
          const seconds = this.math.roundSeconds(state.pace_unit === 'mile' ? row.perMile : row.perKm);
          if (seconds <= 59999) { state.pace_minutes = Math.floor(seconds / 60); state.pace_seconds = seconds % 60; }
          state.speed = Number(row[state.speed_unit].toFixed(6));
        }
      } catch {}
      const query = new URLSearchParams(Object.entries(this.constructor.fieldState(new URLSearchParams(state)))).toString();
      this.tabs.forEach(tab => { tab.href = tab.dataset.calculatorUrl + (query ? `?${query}` : ''); });
    }
    selectedFamily() {
      if (this.mode === 'pace') return this.form.elements.pace_output_unit.value;
      if (this.mode === 'speed') return this.form.elements.speed_output_unit.value;
      return this.form.elements.input_kind.value === 'speed' ? this.form.elements.speed_unit.value : this.form.elements.pace_unit.value;
    }
    syncPaceLinks() {
      const unit = this.selectedFamily();
      this.dataset.paceLinkUnit = unit;
      const family = this.families[unit];
      if (family) {
        const link = this.querySelector('[data-family-link]');
        link.href = family.url;
        link.title = family.title;
        this.querySelector('[data-family-label]').textContent = family.label;
      }
      this.dispatchEvent(new CustomEvent('rw:pace-unit', { detail: { unit } }));
    }
    number(name) {
      const input = this.form.elements[name];
      const raw = String(input.value).trim();
      const value = Number(raw);
      if (raw === '' || !Number.isFinite(value) || value < Number(input.min)
        || (input.max !== '' && value > Number(input.max)) || (input.step === '1' && !Number.isInteger(value))) throw new RangeError('Invalid input');
      return value;
    }
    unitLabel(name, value) {
      return [...this.form.elements[name].options].find(option => option.value === value).text;
    }
    linkResult(node, route) {
      if (route) { node.href = route.url; node.title = route.title; }
      else { node.removeAttribute('href'); node.removeAttribute('title'); }
    }
    compute() {
      const math = this.math;
      const fields = this.form.elements;
      const error = this.querySelector('[data-error-output]');
      try {
        const inputRate = this.mode === 'time' || this.mode === 'distance';
        const speedInput = inputRate && fields.input_kind.value === 'speed';
        const distance = this.mode === 'distance' ? 0 : this.number('distance');
        const time = this.mode === 'time' ? 0 : this.number('hours') * 3600 + this.number('minutes') * 60 + this.number('seconds');
        const pace = inputRate && !speedInput ? this.number('pace_minutes') * 60 + this.number('pace_seconds') : 0;
        const options = speedInput ? { inputKind: 'speed', speed: this.number('speed'), speedUnit: fields.speed_unit.value } : undefined;
        const result = math.calculate(this.mode, distance, fields.unit.value, time, pace, fields.pace_unit.value, options);
        const row = math.row(result.pace);
        const family = this.selectedFamily();
        const speedFamily = ['kmh', 'mph'].includes(family);
        const selectedRate = speedFamily ? math.roundSpeed(row[family]).toFixed(1) : math.paceClock(family === 'mile' ? row.perMile : row.perKm);
        const selectedUnit = this.unitLabel(speedFamily ? 'speed_unit' : 'pace_unit', family);
        const title = this.querySelector('[data-result-title]');
        title.textContent = title.dataset[`${this.mode}Title`];
        const primary = this.querySelector('[data-primary]');
        const secondary = this.querySelector('[data-secondary]');
        const primaryUnit = this.querySelector('[data-primary-unit]');
        const secondaryUnit = this.querySelector('[data-secondary-unit]');
        const rate = this.querySelector('[data-rate]');
        const rateUnit = this.querySelector('[data-rate-unit]');
        if (this.mode === 'pace' || this.mode === 'speed') {
          primary.textContent = selectedRate;
          primaryUnit.textContent = selectedUnit;
          const other = this.mode === 'pace' ? family === 'mile' ? 'km' : 'mile' : family === 'mph' ? 'kmh' : 'mph';
          secondary.textContent = this.mode === 'pace' ? math.paceClock(other === 'mile' ? row.perMile : row.perKm) : math.roundSpeed(row[other]).toFixed(1);
          secondaryUnit.textContent = this.unitLabel(this.mode === 'pace' ? 'pace_unit' : 'speed_unit', other);
          rate.textContent = this.mode === 'pace' ? math.roundSpeed(row.kmh).toFixed(1) : math.paceClock(row.perKm);
          rateUnit.textContent = this.unitLabel(this.mode === 'pace' ? 'speed_unit' : 'pace_unit', this.mode === 'pace' ? 'kmh' : 'km');
        } else {
          primary.textContent = this.mode === 'time' ? math.clock(result.time) : result.km.toFixed(2);
          primaryUnit.textContent = this.mode === 'time' ? '' : this.unitLabel('unit', 'km');
          secondary.textContent = this.mode === 'time' ? String(distance) : (result.km / math.mile).toFixed(2);
          secondaryUnit.textContent = this.unitLabel('unit', this.mode === 'time' ? fields.unit.value : 'mile');
          rate.textContent = selectedRate;
          rateUnit.textContent = selectedUnit;
        }
        const route = this.routes[math.tableTarget(result.pace, family)];
        this.linkResult(this.querySelector('[data-primary-link]'), inputRate ? null : route);
        this.linkResult(this.querySelector('[data-rate-link]'), inputRate ? route : null);
        this.querySelectorAll('[data-race]').forEach(cell => { cell.textContent = math.clock(Number(cell.dataset.race) * result.pace); });
        this.querySelector('[data-race-heading]').textContent = speedFamily ? this.dataset.atSpeed : this.dataset.atPace;
        this.querySelector('[data-constant-note]').textContent = speedFamily ? this.dataset.constantSpeed : this.dataset.constantPace;
        error.hidden = true;
        this.syncPaceLinks();
        this.syncCalculatorLinks();
        return true;
      } catch { error.textContent = this.dataset.error; error.hidden = false; return false; }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-community-story"]) return;
  try {
    
  document.querySelectorAll('.rw-community-story').forEach(story => {
    const share = story.querySelector('[data-story-share-title]');
    if (!share || share.dataset.initialized || !(navigator.share || navigator.clipboard)) return;
    share.dataset.initialized = 'true';
    share.hidden = false;
    share.addEventListener('click', async () => {
      const label = share.querySelector('[data-story-share-label]');
      try {
        if (navigator.share) await navigator.share({ title: share.dataset.storyShareTitle, url: share.dataset.storyShareUrl });
        else {
          await navigator.clipboard.writeText(share.dataset.storyShareUrl);
          label.textContent = share.dataset.copied;
        }
      } catch (error) {
        if (error.name !== 'AbortError') label.textContent = share.dataset.storyShareTitle;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-guidance-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-guidance-library')) {
    customElements.define('rw-guidance-library', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          window.addEventListener('popstate', this.onLocationChange);
          window.addEventListener('hashchange', this.onLocationChange);
          return;
        }
        this.form = this.querySelector('[data-guidance-filter]');
        this.input = this.form?.querySelector('[name="q"]');
        this.category = this.querySelector('[data-guidance-category]');
        if (!this.form || !this.input || !this.category) return;
        this.initialized = true;
        this.groups = Array.from(this.querySelectorAll('[data-guidance-group]'));
        this.topics = Array.from(this.querySelectorAll('[data-guidance-topic]'));
        this.count = this.querySelector('[data-guidance-count]');
        this.countLabel = this.querySelector('[data-guidance-count-label]');
        this.heading = this.querySelector('[data-guidance-heading]');
        this.empty = this.querySelector('[data-guidance-empty]');
        this.reset = this.querySelector('[data-guidance-reset]');
        this.readLocation();
        this.form.hidden = false;
        this.heading.hidden = false;
        this.querySelector('[data-guidance-status]').hidden = false;
        this.classList.add('is-enhanced');
        this.form.addEventListener('submit', event => { event.preventDefault(); this.filter(true); });
        this.input.addEventListener('input', () => this.filter(true));
        this.category.addEventListener('change', () => this.filter(true));
        this.form.addEventListener('reset', event => {
          event.preventDefault();
          this.input.value = '';
          this.category.value = 'all';
          this.filter(true);
        });
        this.topics.forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          this.category.value = link.dataset.guidanceTopic;
          this.filter(true);
        }));
        this.onLocationChange = () => { this.readLocation(); this.filter(); };
        window.addEventListener('popstate', this.onLocationChange);
        window.addEventListener('hashchange', this.onLocationChange);
        this.filter();
      }
      disconnectedCallback() {
        window.removeEventListener('popstate', this.onLocationChange);
        window.removeEventListener('hashchange', this.onLocationChange);
      }
      validGroup(value) { return Array.from(this.category.options).some(option => option.value === value); }
      searchText(value) { return (value || '').normalize('NFKC').toLocaleLowerCase().replace(/[-\u2010-\u2015]/g, ' '); }
      readLocation() {
        const url = new URL(window.location.href);
        const queryGroup = url.searchParams.get('category');
        const hashTopic = this.topics.find(link => link.getAttribute('href') === url.hash);
        this.category.value = this.validGroup(queryGroup) ? queryGroup : hashTopic ? hashTopic.dataset.guidanceTopic : 'all';
        this.input.value = url.searchParams.get('q') || '';
      }
      filter(updateUrl = false) {
        const selected = this.validGroup(this.category.value) ? this.category.value : 'all';
        const words = this.searchText(this.input.value).trim().split(/\s+/).filter(Boolean);
        let count = 0;
        this.groups.forEach(group => {
          let groupCount = 0;
          const inCategory = selected === 'all' || group.dataset.groupKey === selected;
          group.querySelectorAll('[data-guidance-row]').forEach(row => {
            const searchable = this.searchText(row.dataset.search);
            row.hidden = !inCategory || !words.every(word => searchable.includes(word));
            if (!row.hidden) groupCount += 1;
          });
          group.hidden = groupCount === 0;
          count += groupCount;
        });
        this.topics.forEach(link => {
          if (link.dataset.guidanceTopic === selected) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        this.heading.textContent = Array.from(this.category.options).find(option => option.value === selected).textContent;
        this.count.textContent = String(count);
        this.countLabel.textContent = count === 1 ? this.countLabel.dataset.singular : this.countLabel.dataset.plural;
        this.empty.hidden = count > 0;
        this.reset.hidden = !this.input.value && selected === 'all';
        this.classList.toggle('is-scoped', selected !== 'all');
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (selected === 'all') url.searchParams.delete('category');
          else url.searchParams.set('category', selected);
          if (this.input.value.trim()) url.searchParams.set('q', this.input.value.trim());
          else url.searchParams.delete('q');
          if (this.topics.some(link => link.getAttribute('href') === url.hash)) url.hash = '';
          window.history.replaceState(null, '', url);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-product-suggestions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-product-recommendations')) customElements.define('rw-product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-loaded') || this.controller) return;
      this.controller = new AbortController();
      this.dataset.state = 'loading';
      const controller = this.controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      const url = new URL(this.dataset.url, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      fetch(url, { signal: controller.signal, credentials: 'same-origin' })
        .then(response => {
          if (!response.ok) throw new Error('Recommendations unavailable.');
          return response.text();
        })
        .then(text => {
          if (!this.isConnected || controller.signal.aborted) return;
          const document = new DOMParser().parseFromString(text, 'text/html');
          const result = Array.from(document.querySelectorAll('[data-recommendations-section]')).find(element => element.dataset.recommendationsSection === this.dataset.recommendationsSection);
          if (!result || !result.querySelector('[data-product-id]')) {
            this.dataset.state = 'empty';
            this.hidden = true;
            return;
          }
          this.innerHTML = result.innerHTML;
          this.hidden = false;
          this.dataset.state = 'ready';
          this.setAttribute('data-loaded', '');
        })
        .catch(() => {
          if (this.isConnected && this.controller === controller) {
            this.dataset.state = 'unavailable';
            this.hidden = true;
          }
        })
        .finally(() => {
          clearTimeout(timeout);
          if (this.controller === controller) this.controller = null;
        });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-race-date-planner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-race-date-planner')) {
    customElements.define('rw-race-date-planner', class extends HTMLElement {
      async connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        await customElements.whenDefined('rw-race-tools-engine');
        if (!this.isConnected) { this.initialized = false; return; }
        this.math = customElements.get('rw-race-tools-engine').math;
        this.form = this.querySelector('[data-date-form]');
        this.date = this.form.elements.race_date;
        this.distance = this.form.elements.distance;
        this.weeks = this.form.elements.weeks;
        this.cards = Array.from(this.querySelectorAll('[data-plan-card]'));
        this.labels = JSON.parse(this.querySelector('[data-date-labels]').textContent);
        this.error = this.querySelector('[data-date-error]');
        this.results = this.querySelector('[data-date-results]');
        this.placeholder = this.querySelector('[data-date-placeholder]');
        this.today = this.math.todayDate();
        this.date.min = this.today;
        this.formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
        this.form.addEventListener('submit', event => { event.preventDefault(); this.calculate(true); });
        this.form.addEventListener('change', event => {
          if (event.target === this.distance) this.refreshLengths();
          this.clearResults();
        });
        this.date.addEventListener('input', () => this.clearResults());
        this.form.addEventListener('reset', event => {
          event.preventDefault();
          this.distance.value = '';
          this.date.value = '';
          this.refreshLengths('12');
          this.clearResults();
          this.filterPlans();
        });
        const selection = this.math.planSelection(window.location.search);
        if (Array.from(this.distance.options).some(option => option.value === selection.distance)) this.distance.value = selection.distance;
        this.distance.closest('rw-race-tools-select')?.refresh?.();
        this.refreshLengths(selection.weeks ?? '12');
        this.form.hidden = false;
        this.filterPlans();
      }
      refreshLengths(preferred = this.weeks.value) {
        const durations = [...new Set(this.cards.filter(card => !this.distance.value || card.dataset.distance === this.distance.value).map(card => Number(card.dataset.weeks)))].filter(value => Number.isInteger(value) && value > 0).sort((a, b) => a - b);
        this.weeks.replaceChildren(...durations.map(value => {
          const option = document.createElement('option');
          option.value = String(value);
          option.textContent = this.labels.weeks.replace('[count]', value);
          return option;
        }));
        this.weeks.value = durations.includes(Number(preferred)) ? String(preferred) : String(durations[0] || '');
        this.weeks.disabled = durations.length === 0;
        this.weeks.closest('rw-race-tools-select')?.refresh?.();
      }
      clearResults() {
        this.results.hidden = true;
        this.placeholder.hidden = false;
        this.error.hidden = true;
        this.filterPlans();
      }
      formatDate(value) { return this.formatter.format(new Date(`${value}T12:00:00Z`)); }
      calculate(reportValidity = false) {
        this.today = this.math.todayDate();
        this.date.min = this.today;
        if (reportValidity && !this.form.reportValidity()) { this.clearResults(); return; }
        try {
          if (!this.date.value || this.date.value < this.today) throw new RangeError(this.labels.dateError);
          const weeks = Number(this.weeks.value);
          if (!this.cards.some(card => Number(card.dataset.weeks) === weeks && (!this.distance.value || card.dataset.distance === this.distance.value))) throw new RangeError(this.labels.lengthError);
          const result = this.math.raceDate({ raceDate: this.date.value, weeks });
          this.querySelector('[data-start-date]').textContent = this.formatDate(result.startDate);
          this.querySelector('[data-event-date]').textContent = this.formatDate(result.raceDate);
          this.querySelector('[data-week-end]').textContent = this.formatDate(result.weekEnd);
          this.querySelector('[data-week-end-row]').hidden = result.weekday === 0;
          const days = Math.round((Date.parse(`${result.startDate}T12:00:00Z`) - Date.parse(`${this.today}T12:00:00Z`)) / 86400000);
          const timing = days === 0 ? this.labels.today : days > 0 ? this.labels.future : this.labels.past;
          this.querySelector('[data-date-timing]').textContent = timing.replace('[days]', Math.abs(days));
          this.querySelector('[data-date-late]').hidden = days >= 0;
          this.querySelector('[data-date-late-copy]').textContent = days >= -6 ? this.labels.currentWeek : this.labels.alreadyStarted;
          this.querySelector('[data-weekday-note]').hidden = result.weekday === 0;
          this.results.hidden = false;
          this.placeholder.hidden = true;
          this.error.hidden = true;
          this.filterPlans(weeks);
        } catch (error) {
          this.clearResults();
          this.error.textContent = error.message === this.labels.lengthError ? this.labels.lengthError : this.labels.dateError;
          this.error.hidden = false;
        }
      }
      filterPlans(weeks = null) {
        const matching = this.cards.filter(card => (!this.distance.value || card.dataset.distance === this.distance.value) && (!weeks || Number(card.dataset.weeks) === weeks));
        const shown = matching.slice(0, 6);
        this.cards.forEach(card => { card.hidden = !shown.includes(card); });
        this.querySelector('[data-matching-empty]').hidden = matching.length > 0;
        const heading = this.querySelector('[data-plans-heading]');
        if (!this.originalHeading) this.originalHeading = heading.textContent;
        heading.textContent = weeks ? this.labels.matching.replace('[count]', weeks) : this.originalHeading;
        const count = this.querySelector('[data-matching-count]');
        count.textContent = this.labels.count.replace('[shown]', shown.length).replace('[total]', matching.length);
        count.hidden = matching.length === 0;
        const browse = this.querySelector('[data-browse-plans]');
        const url = new URL(this.dataset.directoryUrl, window.location.origin);
        if (this.distance.value) url.searchParams.set('distance', this.distance.value);
        if (weeks) url.searchParams.set('weeks', String(weeks));
        browse.href = `${url.pathname}${url.search}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-race-splits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-race-splits')) customElements.define('rw-race-splits', class extends HTMLElement {
    static bandGroups(rows) {
      const groups = [];
      for (let index = 0; index < rows.length; index += 44) groups.push(rows.slice(index, index + 44));
      return groups;
    }
    static inputTime(fields) {
      const hours = Number(fields.hours.value);
      const minutes = Number(fields.minutes.value);
      const seconds = Number(fields.seconds.value);
      if (![hours, minutes, seconds].every(Number.isInteger) || hours < 0 || hours > 999 || minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59) throw new RangeError('Invalid time');
      const total = hours * 3600 + minutes * 60 + seconds;
      if (total <= 0) throw new RangeError('Invalid time');
      return total;
    }
    async connectedCallback() {
      await customElements.whenDefined('rw-race-tools-engine');
      if (!this.isConnected || this.ready) return;
      this.ready = true;
      this.math = customElements.get('rw-race-tools-engine').math;
      this.form = this.querySelector('form');
      this.fields = this.form.elements;
      this.error = this.querySelector('[data-error-output]');
      this.bands = this.querySelector('[data-band-preview]');
      this.printButton = this.querySelector('[data-print-band]');
      this.customUnit = this.fields.unit.value;
      this.onSubmit = event => { event.preventDefault(); this.calculate(true); };
      this.onChange = event => {
        if (this.syncingSelect) return;
        if (event.target.name === 'preset' && this.fields.preset.value !== 'custom') {
          this.fields.distance.value = this.fields.preset.value;
          this.syncSelect('unit', 'km');
          this.customUnit = 'km';
        } else if (event.target.name === 'unit' && this.fields.preset.value === 'custom') {
          const distance = Number(this.fields.distance.value);
          if (Number.isFinite(distance) && distance > 0 && this.customUnit !== this.fields.unit.value) {
            const converted = this.customUnit === 'mile' ? distance * this.math.mile : distance / this.math.mile;
            this.fields.distance.value = String(Number(converted.toPrecision(12)));
          }
          this.customUnit = this.fields.unit.value;
        }
        this.syncControls();
        this.calculate(false);
      };
      this.onSplitClick = event => {
        const button = event.target.closest('[data-split-unit]');
        if (!button) return;
        this.fields.split_unit.value = button.dataset.splitUnit;
        this.syncControls();
        this.calculate(false);
      };
      this.onNameInput = event => { if (event.target.name === 'race_name' && this.result) this.renderBands(this.result); };
      this.onPrint = () => { if (this.calculate(true)) window.print(); };
      this.form.addEventListener('submit', this.onSubmit);
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('click', this.onSplitClick);
      this.form.addEventListener('input', this.onNameInput);
      this.printButton.addEventListener('click', this.onPrint);
      this.onReference = event => {
        const button = event.target.closest('[data-reference-use]');
        if (button && button.dataset.kind === 'targets') this.useReference(button.dataset);
      };
      this.addEventListener('click', this.onReference);
      for (const button of this.querySelectorAll('[data-reference-use]')) button.hidden = false;
      const selection = this.math.planSelection(window.location.search);
      if (selection.event) {
        const { distance, unit } = selection.event;
        const preset = unit === 'km' && Array.from(this.fields.preset.options).some(option => option.value === String(distance)) ? String(distance) : 'custom';
        this.syncSelect('preset', preset);
        this.fields.distance.value = String(distance);
        this.syncSelect('unit', unit);
        this.customUnit = unit;
      }
      this.syncControls();
      this.calculate(false);
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('click', this.onSplitClick);
      this.form?.removeEventListener('input', this.onNameInput);
      this.printButton?.removeEventListener('click', this.onPrint);
      this.removeEventListener('click', this.onReference);
      this.cleanupPrint();
      this.ready = false;
    }
    number(value) { return Number(value.toFixed(4)).toLocaleString(undefined, { maximumFractionDigits: 4 }); }
    useReference(data) {
      const distance = Number(data.distance);
      const time = Number(data.time);
      if (![5, 10, 21.0975, 42.195].includes(distance) || !Number.isInteger(time) || time <= 0 || time > 604800) return;
      this.fields.hours.value = String(Math.floor(time / 3600));
      this.fields.minutes.value = String(Math.floor(time % 3600 / 60));
      this.fields.seconds.value = String(time % 60);
      this.syncSelect('preset', String(distance));
      this.fields.distance.value = String(distance);
      this.syncSelect('unit', 'km');
      this.customUnit = 'km';
      this.syncControls();
      this.calculate(false);
      this.form.scrollIntoView?.({ block: 'start' });
      this.fields.hours.focus?.({ preventScroll: true });
    }
    syncSelect(name, value) {
      this.fields[name].value = value;
      this.syncingSelect = true;
      try { this.fields[name].dispatchEvent(new Event('change', { bubbles: true })); } finally { this.syncingSelect = false; }
    }
    syncControls() {
      const custom = this.fields.preset.value === 'custom';
      this.querySelector('[data-custom-distance]').hidden = !custom;
      this.fields.distance.disabled = !custom;
      this.fields.unit.disabled = !custom;
      const miles = this.fields.split_unit.value === 'mile';
      this.querySelector('[data-five-km]').hidden = miles;
      this.fields.five_km.disabled = miles;
      for (const button of this.querySelectorAll('[data-split-unit]')) button.setAttribute('aria-pressed', String(button.dataset.splitUnit === this.fields.split_unit.value));
    }
    distanceLabel() {
      if (this.fields.preset.value !== 'custom') return this.fields.preset.selectedOptions[0].textContent.trim();
      return `${this.number(Number(this.fields.distance.value))} ${this.fields.unit.value === 'mile' ? this.dataset.mile : this.dataset.km}`;
    }
    rowLabel(row, result) { return row.finish ? this.dataset.finish : `${this.number(row.distance)} ${result.intervalUnit === 'mile' ? this.dataset.mile : this.dataset.km}`; }
    createNode(tag, text, className) {
      const node = document.createElement(tag);
      if (text !== undefined) node.textContent = text;
      if (className) node.className = className;
      return node;
    }
    calculate(report) {
      try {
        if (!this.form.checkValidity()) { if (report) this.form.reportValidity(); throw new RangeError('Invalid fields'); }
        const custom = this.fields.preset.value === 'custom';
        const interval = this.fields.split_unit.value === 'mile' ? 'mile' : this.fields.five_km.checked ? '5km' : 'km';
        const result = this.math.splits({ distance: Number(custom ? this.fields.distance.value : this.fields.preset.value), unit: custom ? this.fields.unit.value : 'km', time: this.constructor.inputTime(this.fields), interval });
        this.querySelector('[data-result-time]').textContent = this.math.clock(result.time);
        this.querySelector('[data-result-km]').textContent = this.math.paceClock(result.pace);
        this.querySelector('[data-result-mile]').textContent = this.math.paceClock(result.pace * this.math.mile);
        this.querySelector('[data-result-halfway]').textContent = this.math.clock(result.time / 2);
        const rows = result.rows.map(row => {
          const tr = this.createNode('tr');
          const th = this.createNode('th', this.rowLabel(row, result));
          th.scope = 'row';
          if (row.finish) { tr.className = 'rw-race-splits__finish'; th.append(this.createNode('span', this.distanceLabel())); }
          tr.append(th, this.createNode('td', this.math.clock(row.time)));
          return tr;
        });
        this.querySelector('[data-split-rows]').replaceChildren(...rows);
        this.result = result;
        this.renderBands(result);
        this.querySelector('.rw-race-tool__results').hidden = false;
        this.querySelector('.rw-race-splits__band-section').hidden = false;
        this.error.hidden = true;
        this.printButton.hidden = false;
        this.printButton.disabled = false;
        this.querySelector('[data-print-note]').hidden = false;
        return true;
      } catch {
        this.result = null;
        this.cleanupPrint();
        this.querySelector('.rw-race-tool__results').hidden = true;
        this.querySelector('.rw-race-splits__band-section').hidden = true;
        this.error.textContent = this.dataset.error;
        this.error.hidden = false;
        this.printButton.disabled = true;
        return false;
      }
    }
    renderBands(result) {
      const groups = this.constructor.bandGroups(result.rows);
      const title = this.fields.race_name.value.trim() || this.dataset.bandTitle;
      const distance = this.distanceLabel();
      const strips = groups.map((group, index) => {
        const strip = this.createNode('div', undefined, 'rw-pace-band');
        const label = this.createNode('div', undefined, 'rw-pace-band__label');
        label.append(this.createNode('strong', title), this.createNode('span', distance), this.createNode('span', `${this.dataset.target} ${this.math.clock(result.time)}`), this.createNode('small', `${this.dataset.evenPace} | ${this.dataset.part} ${index + 1}/${groups.length}`));
        const points = this.createNode('div', undefined, 'rw-pace-band__points');
        points.setAttribute('style', `--band-columns: ${Math.min(11, group.length)}; --band-rows: ${Math.ceil(group.length / 11)};`);
        for (const row of group) {
          const point = this.createNode('div', undefined, `rw-pace-band__point${row.finish ? ' rw-pace-band__point--finish' : ''}`);
          point.append(this.createNode('span', this.rowLabel(row, result)), this.createNode('strong', this.math.clock(row.time)));
          points.append(point);
        }
        strip.append(label, points, this.createNode('span', this.dataset.join, 'rw-pace-band__join'));
        return strip;
      });
      this.bands.replaceChildren(...strips);
      this.preparePrint();
    }
    preparePrint() {
      if (!this.result) return;
      if (!this.printSheet) {
        this.printSheet = this.createNode('div', undefined, 'rw-race-splits-print-sheet');
        this.printSheet.setAttribute('aria-hidden', 'true');
        document.body.append(this.printSheet);
      }
      this.printSheet.replaceChildren(...Array.from(this.bands.children, band => band.cloneNode(true)));
    }
    cleanupPrint() {
      this.printSheet?.remove();
      this.printSheet = null;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-recently-viewed')) customElements.define('rw-recently-viewed', class extends HTMLElement {
    static history(raw, now = Date.now()) {
      if (typeof raw !== 'string' || raw.length > 8192) return [];
      try {
        const entries = JSON.parse(raw);
        if (!Array.isArray(entries) || entries.length > 128) return [];
        const seen = new Set();
        return entries.filter(entry => entry && this.validHandle(entry.handle) && Number.isFinite(entry.at) && entry.at > 0 && entry.at <= now && now - entry.at < 2592000000)
          .sort((a, b) => b.at - a.at)
          .filter(entry => { if (seen.has(entry.handle)) return false; seen.add(entry.handle); return true; })
          .slice(0, 12).map(({ handle, at }) => ({ handle, at }));
      } catch { return []; }
    }

    static validHandle(handle) { return typeof handle === 'string' && handle.length <= 200 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle); }

    static productUrl(handle, root, section, current) {
      if (!this.validHandle(handle) || !/^[a-zA-Z0-9_-]{1,120}$/.test(section)) return null;
      const origin = new URL(current);
      const base = new URL(root, origin);
      if (base.origin !== origin.origin || base.search || base.hash) return null;
      const url = new URL(`${base.pathname.replace(/\/?$/, '/')}products/${encodeURIComponent(handle)}`, origin);
      url.searchParams.set('section_id', section);
      for (const key of ['preview_theme_id', '_ab', '_fd', '_sc']) if (origin.searchParams.has(key)) url.searchParams.set(key, origin.searchParams.get(key));
      return url;
    }

    connectedCallback() {
      if (this.ownerDocument !== document || !this.isConnected || this.active) return;
      this.active = true;
      this.hidden = true;
      this.track = this.querySelector('[data-product-carousel-track]');
      if (!this.track || !/^rw-recently-viewed:[1-9][0-9]{0,19}$/.test(this.dataset.storageKey) || !this.constructor.validHandle(this.dataset.productHandle)) return;
      this.onConsent = () => this.updateConsent();
      this.onStorage = event => { if (event.key === this.dataset.storageKey) { if (this.permitted()) this.refresh(false); else this.revoke(); } };
      this.onClear = () => this.clearHistory();
      this.onReady = () => this.loadPrivacy();
      document.addEventListener('visitorConsentCollected', this.onConsent);
      document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      window.addEventListener('load', this.onReady, { once: true });
      window.addEventListener('storage', this.onStorage);
      this.querySelector('[data-clear-recently-viewed]')?.addEventListener('click', this.onClear);
      this.loadPrivacy(true);
    }

    disconnectedCallback() {
      this.active = false;
      this.cancel();
      document.removeEventListener('visitorConsentCollected', this.onConsent);
      document.removeEventListener('DOMContentLoaded', this.onReady);
      window.removeEventListener('load', this.onReady);
      window.removeEventListener('storage', this.onStorage);
      this.querySelector('[data-clear-recently-viewed]')?.removeEventListener('click', this.onClear);
    }

    permitted() {
      try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; }
      catch { return false; }
    }

    loadPrivacy(refreshExisting = false) {
      if (!this.active || !this.isConnected || this.loadingPrivacy) return;
      if (typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function') { if (refreshExisting || !this.hasPermission || !this.permitted()) this.updateConsent(); return; }
      if (typeof window.Shopify?.loadFeatures !== 'function') { this.revoke(); return; }
      try {
        this.loadingPrivacy = true;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          this.loadingPrivacy = false;
          if (!this.active || !this.isConnected) return;
          if (error) this.revoke();
          else this.updateConsent();
        });
      } catch { this.loadingPrivacy = false; this.revoke(); }
    }

    updateConsent() {
      if (!this.permitted()) { this.revoke(); return; }
      const recordCurrent = !this.hasPermission;
      this.hasPermission = true;
      this.refresh(recordCurrent);
    }

    readHistory() {
      if (!this.permitted()) return [];
      try { return this.constructor.history(window.localStorage.getItem(this.dataset.storageKey)); }
      catch { return []; }
    }

    writeHistory(history) {
      if (!this.permitted()) return;
      try { window.localStorage.setItem(this.dataset.storageKey, JSON.stringify(history)); }
      catch {}
    }

    cancel() {
      this.sequence = (this.sequence || 0) + 1;
      this.controller?.abort();
      clearTimeout(this.requestTimeout);
      this.requestTimeout = null;
      this.hidden = true;
      this.track?.replaceChildren();
    }

    revoke() {
      const previouslyAllowed = this.hasPermission;
      this.hasPermission = false;
      this.cancel();
      if (previouslyAllowed) { try { window.localStorage.removeItem(this.dataset.storageKey); } catch {} }
    }

    clearHistory() {
      if (!this.permitted()) { this.revoke(); return; }
      this.cancel();
      try { window.localStorage.removeItem(this.dataset.storageKey); } catch {}
    }

    async fetchCard(handle, signal) {
      if (!this.permitted() || signal.aborted) return null;
      try {
        const url = this.constructor.productUrl(handle, this.dataset.rootUrl, this.dataset.sectionId, location.href);
        if (!url) return null;
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal });
        if (!response.ok || !this.permitted() || signal.aborted) return null;
        const html = await response.text();
        if (html.length > 262144 || !this.permitted() || signal.aborted) return null;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const card = parsed.querySelector('template[data-product-card]')?.content.querySelector('li.rw-product-carousel__item');
        if (!card || !/^[1-9][0-9]{0,19}$/.test(card.dataset.productId) || card.dataset.productHandle !== handle || card.dataset.productId === this.dataset.productId) return null;
        const links = [...card.querySelectorAll('a[href]')];
        if (!links.length || links.some(link => { const target = new URL(link.getAttribute('href'), location.origin); return target.origin !== url.origin || target.pathname !== url.pathname; })) return null;
        card.querySelectorAll('script, style, iframe, object, embed, link, form').forEach(element => element.remove());
        [card, ...card.querySelectorAll('*')].forEach(element => [...element.attributes].forEach(attribute => { if (attribute.name.startsWith('on')) element.removeAttribute(attribute.name); }));
        return document.importNode(card, true);
      } catch { return null; }
    }

    async refresh(recordCurrent) {
      if (!this.active || !this.isConnected || !this.permitted()) { this.revoke(); return; }
      this.cancel();
      const sequence = this.sequence;
      const history = this.readHistory();
      const previous = history.filter(entry => entry.handle !== this.dataset.productHandle);
      if (recordCurrent) {
        if (!this.permitted()) { this.revoke(); return; }
        this.writeHistory([{ handle: this.dataset.productHandle, at: Date.now() }, ...previous].slice(0, 12));
      }
      if (!previous.length) return;
      this.controller = new AbortController();
      const controller = this.controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      this.requestTimeout = timeout;
      try {
        const cards = await Promise.all(previous.map(entry => this.fetchCard(entry.handle, controller.signal)));
        if (!this.active || !this.isConnected || controller.signal.aborted || sequence !== this.sequence) return;
        if (!this.permitted()) { this.revoke(); return; }
        const seen = new Set();
        const limit = Math.min(8, Math.max(2, Number(this.dataset.productCount) || 8));
        const available = cards.filter(card => { if (!card || seen.has(card.dataset.productId)) return false; seen.add(card.dataset.productId); return true; }).slice(0, limit);
        this.track.replaceChildren(...available);
        this.hidden = available.length === 0;
      } finally {
        clearTimeout(timeout);
        if (this.requestTimeout === timeout) this.requestTimeout = null;
        if (this.controller === controller) this.controller = null;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-review-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-review-gallery')) customElements.define('rw-review-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const controller = this.controller;
      this.events = new AbortController();
      this.track = this.querySelector('[data-review-gallery-track]');
      this.previous = this.querySelector('[data-review-gallery-previous]');
      this.next = this.querySelector('[data-review-gallery-next]');
      this.dialog = this.querySelector('[data-review-gallery-dialog]');
      this.labels = JSON.parse(this.querySelector('[data-review-gallery-labels]').textContent);
      this.previous.addEventListener('click', () => this.move(-1), { signal: this.events.signal });
      this.next.addEventListener('click', () => this.move(1), { signal: this.events.signal });
      this.track.addEventListener('scroll', () => this.updateControls(), { signal: this.events.signal });
      window.addEventListener('pageshow', event => {
        if (event.persisted && this.reviewPool && !this.dialog.open) this.renderReviews(this.reviewPool);
      }, { signal: this.events.signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal: this.events.signal });
      this.querySelector('[data-review-gallery-close]').addEventListener('click', () => this.dialog.close(), { signal: this.events.signal });
      this.dialog.addEventListener('close', () => this.restoreFocus(), { signal: this.events.signal });
      this.dialog.querySelector('[data-review-gallery-photo-previous]').addEventListener('click', () => this.showPhoto(this.photoIndex - 1), { signal: this.events.signal });
      this.dialog.querySelector('[data-review-gallery-photo-next]').addEventListener('click', () => this.showPhoto(this.photoIndex + 1), { signal: this.events.signal });
      this.resize = new ResizeObserver(() => this.updateControls());
      this.resize.observe(this.track);
      if (this.dataset.source === 'shopify') {
        try {
          const reviews = this.reviewPool || [...this.querySelectorAll('[data-review-gallery-native-review]')].map(node => JSON.parse(node.textContent));
          this.renderReviews(reviews);
          this.classList.add('is-enhanced');
        } catch { this.hidden = true; }
        this.controller = null;
        return;
      }
      const timeout = setTimeout(() => controller.abort(), 10000);
      Promise.resolve().then(() => {
        const url = this.safeUrl(`${this.dataset.apiBase.replace(/\/$/, '')}/api/reviews/photos`);
        if (!url) throw new Error('Review gallery endpoint must be same-origin.');
        url.searchParams.set('limit', '40');
        url.searchParams.set('minRating', '4');
        return fetch(url, { credentials: 'same-origin', signal: controller.signal });
      }).then(response => {
        if (!response.ok) throw new Error('Review gallery unavailable.');
        return response.json();
      }).then(result => {
        if (!this.isConnected || controller.signal.aborted) return;
        this.renderReviews(result.reviews);
      }).catch(() => { this.hidden = true; }).finally(() => {
        clearTimeout(timeout);
        if (this.controller === controller) this.controller = null;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.events?.abort();
      this.resize?.disconnect();
      if (this.dialog?.open) this.dialog.close();
    }
    text(key, values = {}) {
      let text = this.labels[key] || '';
      Object.entries(values).forEach(([name, value]) => { text = text.replaceAll(`[${name}]`, String(value)); });
      return text;
    }
    safeUrl(value) {
      if (typeof value !== 'string') return null;
      let url;
      try { url = new URL(value, location.origin); } catch { return null; }
      if (!['http:', 'https:'].includes(url.protocol) || url.origin !== location.origin || url.username || url.password) return null;
      return url;
    }
    safePhotoUrl(value) {
      if (this.dataset.source !== 'shopify') return this.safeUrl(value);
      if (typeof value !== 'string' || /[\u0000-\u0020\u007f\\]/.test(value)) return null;
      let url;
      try { url = new URL(value); } catch { return null; }
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com' || url.port || url.username || url.password || url.hash
        || !url.pathname.startsWith('/s/files/') || !/\.(?:jpe?g|png|webp|avif|gif)$/i.test(url.pathname)) return null;
      return url;
    }
    renderReviews(reviews) {
      this.track.replaceChildren();
      if (!Array.isArray(reviews)) { this.reviewPool = []; this.hidden = true; return; }
      const eligible = [];
      for (const review of reviews) {
        if (!review || typeof review !== 'object') continue;
        if (!Number.isInteger(review.rating) || review.rating < 4 || review.rating > 5) continue;
        const photos = Array.isArray(review.photos) ? review.photos.filter(candidate => this.safePhotoUrl(candidate?.url)) : [];
        if (!photos.length) continue;
        eligible.push({ ...review, photos });
        if (eligible.length === 40) break;
      }
      this.reviewPool = eligible.slice();
      // Shuffle the approved pool locally; the cached Shopify feed remains unchanged.
      for (let index = eligible.length - 1; index > 0; index--) {
        const other = Math.floor(Math.random() * (index + 1));
        [eligible[index], eligible[other]] = [eligible[other], eligible[index]];
      }
      const limit = Math.min(20, Math.max(4, Math.trunc(Number(this.dataset.reviewLimit)) || 12));
      for (const review of eligible.slice(0, limit)) {
        const item = this.card(review, review.photos);
        this.track.append(item);
      }
      this.track.scrollLeft = 0;
      this.hidden = !this.track.children.length;
      this.updateControls();
    }
    icon(name) {
      return this.querySelector(`[data-review-gallery-${name}-icon]`)?.content.cloneNode(true);
    }
    stars(review) {
      const stars = document.createElement('span');
      stars.className = 'rw-review-gallery__stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', this.text('rating', { rating: review.rating }));
      stars.textContent = '\u2605'.repeat(review.rating) + '\u2606'.repeat(5 - review.rating);
      return stars;
    }
    identity(review) {
      const identity = document.createElement('div');
      identity.className = 'rw-review-gallery__identity';
      if (typeof review.displayName === 'string' && review.displayName.trim()) {
        const name = document.createElement('span');
        name.className = 'rw-review-gallery__name';
        name.textContent = review.displayName;
        identity.append(name);
      }
      if (review.verification === 'purchase' || review.verification === 'customer') {
        const badge = document.createElement('span');
        badge.className = 'rw-review-gallery__badge';
        badge.textContent = this.text(review.verification);
        identity.append(badge);
      }
      return identity;
    }
    subject(review) {
      const url = this.safeUrl(review.subject?.url);
      if (!url || !/^\/(?:products|pages|blogs)\//.test(url.pathname) || typeof review.subject?.title !== 'string' || !review.subject.title.trim()) return null;
      const link = document.createElement('a');
      link.className = 'rw-review-gallery__subject';
      link.href = url.href;
      link.title = review.subject.title;
      const label = document.createElement('span');
      label.textContent = review.subject.title;
      link.append(label);
      const icon = this.icon('arrow');
      if (icon) link.append(icon);
      return link;
    }
    card(review, photos) {
      const photo = photos[0];
      const item = document.createElement('li');
      item.className = 'rw-review-gallery__card';
      const photoButton = document.createElement('button');
      photoButton.type = 'button';
      photoButton.className = 'rw-review-gallery__photo';
      const image = document.createElement('img');
      image.src = this.safePhotoUrl(photo.url).href;
      image.alt = typeof photo.alt === 'string' && photo.alt.trim() ? photo.alt : this.text('photo', { name: review.displayName });
      image.width = Number(photo.width) || 800;
      image.height = Number(photo.height) || 1000;
      image.loading = 'lazy';
      image.decoding = 'async';
      photoButton.setAttribute('aria-label', this.text('open', { name: review.displayName }));
      photoButton.title = this.text('open', { name: review.displayName });
      photoButton.append(image);
      const zoom = document.createElement('span');
      zoom.className = 'rw-review-gallery__zoom';
      zoom.setAttribute('aria-hidden', 'true');
      const zoomIcon = this.icon('zoom');
      if (zoomIcon) zoom.append(zoomIcon);
      photoButton.append(zoom);
      image.addEventListener('error', () => {
        item.remove();
        this.hidden = !this.track.children.length;
        this.updateControls();
      }, { signal: this.events.signal });
      photoButton.addEventListener('click', () => this.openReview(review, photos, photoButton), { signal: this.events.signal });
      const content = document.createElement('div');
      content.className = 'rw-review-gallery__content';
      content.append(this.stars(review));
      if (typeof review.title === 'string' && review.title.trim()) {
        const title = document.createElement('h3');
        title.textContent = review.title;
        content.append(title);
      }
      if (typeof review.body === 'string' && review.body.trim()) {
        const body = document.createElement('p');
        body.className = 'rw-review-gallery__excerpt';
        body.textContent = review.body;
        content.append(body);
      }
      const read = document.createElement('button');
      read.type = 'button';
      read.className = 'rw-review-gallery__read';
      read.textContent = this.text('read');
      read.setAttribute('aria-label', this.text('open', { name: review.displayName }));
      read.addEventListener('click', () => this.openReview(review, photos, read), { signal: this.events.signal });
      content.append(read, this.identity(review));
      const subject = this.subject(review);
      if (subject) content.append(subject);
      item.append(photoButton, content);
      return item;
    }
    openReview(review, photos, trigger) {
      this.dialogTrigger = trigger;
      this.currentReview = review;
      this.photos = photos;
      const content = this.dialog.querySelector('[data-review-gallery-full-content]');
      content.replaceChildren(this.stars(review));
      if (typeof review.title === 'string' && review.title.trim()) {
        const title = document.createElement('h3');
        title.textContent = review.title;
        content.append(title);
      }
      if (typeof review.body === 'string' && review.body.trim()) {
        const body = document.createElement('p');
        body.className = 'rw-review-gallery__full-body';
        body.textContent = review.body;
        content.append(body);
      }
      content.append(this.identity(review));
      if (typeof review.reply?.body === 'string' && review.reply.body.trim()) {
        const reply = document.createElement('section');
        reply.className = 'rw-review-gallery__reply';
        const heading = document.createElement('h4');
        heading.textContent = this.text('reply');
        const body = document.createElement('p');
        body.textContent = review.reply.body;
        reply.append(heading, body);
        content.append(reply);
      }
      const subject = this.subject(review);
      if (subject) content.append(subject);
      this.showPhoto(0);
      this.dialog.showModal();
      this.querySelector('[data-review-gallery-close]').focus();
    }
    showPhoto(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.photos.length) return;
      this.photoIndex = index;
      const photo = this.photos[index];
      const image = document.createElement('img');
      image.src = this.safePhotoUrl(photo.url).href;
      image.alt = typeof photo.alt === 'string' && photo.alt.trim() ? photo.alt : this.text('photoNumber', { current: index + 1, total: this.photos.length, name: this.currentReview.displayName });
      image.width = Number(photo.width) || 800;
      image.height = Number(photo.height) || 1000;
      image.decoding = 'async';
      this.dialog.querySelector('[data-review-gallery-full-photo]').replaceChildren(image);
      this.dialog.querySelector('[data-review-gallery-photo-controls]').hidden = this.photos.length < 2;
      this.dialog.querySelector('[data-review-gallery-photo-count]').textContent = this.text('photoCount', { current: index + 1, total: this.photos.length });
      const previous = this.dialog.querySelector('[data-review-gallery-photo-previous]');
      const next = this.dialog.querySelector('[data-review-gallery-photo-next]');
      const focused = document.activeElement;
      previous.disabled = index === 0;
      next.disabled = index === this.photos.length - 1;
      this.preserveControlFocus(previous, next, this.querySelector('[data-review-gallery-close]'), focused);
    }
    restoreFocus() {
      if (this.dialogTrigger?.isConnected) this.dialogTrigger.focus();
    }
    preserveControlFocus(previous, next, fallback, focused) {
      if (focused === previous && previous.disabled) (next.disabled ? fallback : next).focus();
      if (focused === next && next.disabled) (previous.disabled ? fallback : previous).focus();
    }
    updateControls() {
      if (!this.track) return;
      const focused = document.activeElement;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      if (!this.hidden) this.preserveControlFocus(this.previous, this.next, this.track, focused);
    }
    move(direction) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-run-walk-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-run-walk-calculator')) customElements.define('rw-run-walk-calculator', class extends HTMLElement {
    static duration(minutes, seconds) {
      const minute = Number(minutes);
      const second = Number(seconds);
      if (String(minutes).trim() === '' || String(seconds).trim() === '' || !Number.isInteger(minute) || !Number.isInteger(second) || minute < 0 || minute > 120 || second < 0 || second > 59) throw new RangeError('Invalid minutes or seconds');
      return minute * 60 + second;
    }
    async connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      await customElements.whenDefined('rw-race-tools-engine');
      if (!this.isConnected) { this.ready = false; return; }
      this.math = customElements.get('rw-race-tools-engine').math;
      this.form = this.querySelector('form');
      this.results = this.querySelector('[data-results]');
      this.errorOutput = this.querySelector('[data-error-output]');
      this.form.addEventListener('submit', event => { event.preventDefault(); this.calculate(true); });
      this.form.addEventListener('input', () => this.invalidate());
      this.form.addEventListener('change', () => this.invalidate());
      this.form.addEventListener('reset', () => { setTimeout(() => this.calculate(false), 0); });
      this.querySelectorAll('.rw-race-tool__presets [data-distance]').forEach(button => button.addEventListener('click', () => {
        this.form.elements.distance.value = button.dataset.distance;
        this.form.elements.unit.value = 'km';
        this.form.elements.unit.dispatchEvent(new Event('change', { bubbles: true }));
        this.calculate(false);
      }));
      this.onReference = event => {
        const button = event.target.closest('[data-reference-use]');
        if (button && button.dataset.kind === 'run-walk') this.useReference(button.dataset);
      };
      this.addEventListener('click', this.onReference);
      for (const button of this.querySelectorAll('[data-reference-use]')) button.hidden = false;
      const selection = this.math.planSelection(window.location.search);
      if (selection.event) {
        this.form.elements.distance.value = String(selection.event.distance);
        this.form.elements.unit.value = selection.event.unit;
        this.form.elements.unit.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.calculate(false);
    }
    useReference(data) {
      const distance = Number(data.distance);
      const run = Number(data.runSeconds);
      const walk = Number(data.walkSeconds);
      if (![5, 10, 21.0975, 42.195].includes(distance) || ![60, 120, 180, 240, 300, 600].includes(run) || walk !== 60) return;
      const fields = this.form.elements;
      fields.distance.value = String(distance);
      for (const [prefix, seconds] of [['run', run], ['walk', walk], ['run_pace', 420], ['walk_pace', 600]]) {
        fields[`${prefix}_minutes`].value = String(Math.floor(seconds / 60));
        fields[`${prefix}_seconds`].value = String(seconds % 60);
      }
      for (const name of ['unit', 'pace_unit']) {
        fields[name].value = 'km';
        fields[name].dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.calculate(false);
      this.form.scrollIntoView?.({ block: 'start' });
      fields.distance.focus?.({ preventScroll: true });
    }
    invalidate() {
      this.results.hidden = true;
      this.errorOutput.hidden = true;
    }
    durationFor(prefix) {
      const fields = this.form.elements;
      return this.constructor.duration(fields[`${prefix}_minutes`].value, fields[`${prefix}_seconds`].value);
    }
    calculate(report = false) {
      const fields = this.form.elements;
      try {
        if (!this.form.checkValidity()) throw new RangeError(this.dataset.error);
        const distance = Number(fields.distance.value);
        if (!Number.isFinite(distance) || distance < 0.01 || distance > 1000) throw new RangeError(this.dataset.distanceError);
        let runSeconds;
        let walkSeconds;
        let runPace;
        let walkPace;
        try { runSeconds = this.durationFor('run'); } catch { throw new RangeError(this.dataset.runError); }
        try { walkSeconds = this.durationFor('walk'); } catch { throw new RangeError(this.dataset.walkError); }
        if (runSeconds <= 0) throw new RangeError(this.dataset.runError);
        if (walkSeconds <= 0) throw new RangeError(this.dataset.walkError);
        try { runPace = this.durationFor('run_pace'); walkPace = this.durationFor('walk_pace'); } catch { throw new RangeError(this.dataset.paceError); }
        if (runPace <= 0 || walkPace <= 0) throw new RangeError(this.dataset.paceError);
        const result = this.math.runWalk({ distance, unit: fields.unit.value, runSeconds, walkSeconds, runPace, walkPace, paceUnit: fields.pace_unit.value });
        const fraction = result.runTime / result.time;
        const output = (key, value) => { this.querySelector(`[data-result="${key}"]`).textContent = value; };
        const partial = [];
        if (result.partialRunTime > 1e-8) partial.push(`${this.math.clock(result.partialRunTime)} ${this.dataset.runningLabel}`);
        if (result.partialWalkTime > 1e-8) partial.push(`${this.math.clock(result.partialWalkTime)} ${this.dataset.walkingLabel}`);
        output('time', this.math.clock(result.time));
        output('km', String(Number(result.km.toFixed(2))));
        output('miles', String(Number((result.km / this.math.mile).toFixed(2))));
        output('pace', this.math.paceClock(result.pace));
        output('mile_pace', this.math.paceClock(result.pace * this.math.mile));
        output('run_time', this.math.clock(result.runTime));
        output('walk_time', this.math.clock(result.walkTime));
        output('repeats', String(result.completeCycles));
        output('partial', partial.length ? partial.join(' + ') : this.dataset.noPartial);
        output('run_percent', `${Math.round(fraction * 100)}%`);
        output('walk_percent', `${100 - Math.round(fraction * 100)}%`);
        this.querySelector('[data-proportion-run]').style.width = `${fraction * 100}%`;
        this.querySelector('[data-proportion-walk]').style.width = `${(1 - fraction) * 100}%`;
        this.errorOutput.hidden = true;
        this.results.hidden = false;
      } catch (error) {
        this.results.hidden = true;
        this.errorOutput.textContent = Object.values(this.dataset).includes(error.message) ? error.message : this.dataset.error;
        this.errorOutput.hidden = false;
        if (report) this.form.reportValidity();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-session-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-session-library')) {
    customElements.define('rw-session-library', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          window.addEventListener('popstate', this.onLocationChange);
          window.addEventListener('hashchange', this.onLocationChange);
          return;
        }
        this.initialized = true;
        this.form = this.querySelector('[data-session-filter]');
        this.input = this.form.querySelector('[name="q"]');
        this.category = this.querySelector('[data-session-category]');
        this.groups = Array.from(this.querySelectorAll('[data-session-group]'));
        this.topics = Array.from(this.querySelectorAll('[data-session-topic]'));
        this.count = this.querySelector('[data-session-count]');
        this.heading = this.querySelector('[data-session-heading]');
        this.empty = this.querySelector('[data-session-empty]');
        this.reset = this.querySelector('[data-session-reset]');
        this.defaultGroup = this.validGroup(this.dataset.defaultGroup) ? this.dataset.defaultGroup : 'all';
        this.readLocation();
        this.form.hidden = false;
        this.heading.hidden = false;
        this.querySelector('[data-session-status]').hidden = false;
        this.classList.add('is-enhanced');
        this.form.addEventListener('submit', event => { event.preventDefault(); this.filter(true); });
        this.input.addEventListener('input', () => this.filter(true));
        this.category.addEventListener('change', () => this.filter(true));
        this.form.addEventListener('reset', event => {
          event.preventDefault();
          this.input.value = '';
          this.category.value = this.defaultGroup;
          this.filter(true);
        });
        this.topics.forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          this.category.value = link.dataset.sessionTopic;
          this.filter(true);
        }));
        this.onLocationChange = () => { this.readLocation(); this.filter(); };
        window.addEventListener('popstate', this.onLocationChange);
        window.addEventListener('hashchange', this.onLocationChange);
        this.filter();
      }
      disconnectedCallback() {
        window.removeEventListener('popstate', this.onLocationChange);
        window.removeEventListener('hashchange', this.onLocationChange);
      }
      validGroup(value) { return Array.from(this.category.options).some(option => option.value === value); }
      searchText(value) { return value.normalize('NFKC').toLocaleLowerCase().replace(/[-\u2010-\u2015]/g, ' '); }
      readLocation() {
        const url = new URL(window.location.href);
        const queryGroup = url.searchParams.get('category');
        const hashTopic = this.topics.find(link => link.getAttribute('href') === url.hash);
        this.category.value = this.validGroup(queryGroup) ? queryGroup : hashTopic ? hashTopic.dataset.sessionTopic : this.defaultGroup;
        this.input.value = url.searchParams.get('q') || '';
      }
      filter(updateUrl = false) {
        const selected = this.validGroup(this.category.value) ? this.category.value : this.defaultGroup;
        const words = this.searchText(this.input.value).trim().split(/\s+/).filter(Boolean);
        let count = 0;
        this.groups.forEach(group => {
          let groupCount = 0;
          const inCategory = selected === 'all' || group.dataset.groupKey === selected;
          group.querySelectorAll('[data-session-row]').forEach(row => {
            const searchable = this.searchText(row.dataset.search);
            const visible = inCategory && words.every(word => searchable.includes(word));
            row.hidden = !visible;
            if (visible) groupCount += 1;
          });
          group.hidden = groupCount === 0;
          const groupCountLabel = group.querySelector('[data-group-count]');
          if (groupCountLabel) groupCountLabel.textContent = String(groupCount);
          group.querySelectorAll('[data-session-highlight]').forEach(highlight => { highlight.hidden = words.length > 0; });
          count += groupCount;
        });
        this.topics.forEach(link => {
          if (link.dataset.sessionTopic === selected) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        this.heading.textContent = Array.from(this.category.options).find(option => option.value === selected).textContent;
        this.count.textContent = String(count);
        const countLabel = this.querySelector('[data-session-count-label]');
        if (countLabel) countLabel.textContent = count === 1 ? countLabel.dataset.singular : countLabel.dataset.plural;
        this.empty.hidden = count > 0;
        this.reset.hidden = !this.input.value && selected === this.defaultGroup;
        this.classList.toggle('is-scoped', selected !== 'all');
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (selected === this.defaultGroup) url.searchParams.delete('category');
          else url.searchParams.set('category', selected);
          if (this.input.value.trim()) url.searchParams.set('q', this.input.value.trim());
          else url.searchParams.delete('q');
          if (this.topics.some(link => link.getAttribute('href') === url.hash)) url.hash = '';
          window.history.replaceState(null, '', url);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-shop-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-shop-strip')) {
    class RunningWomanShopStrip extends HTMLElement {
      connectedCallback() {
        if (this.media) return;
        this.groups = Array.from(this.querySelectorAll('[data-shop-strip-group]')).map(group => ({
          group,
          heading: group.querySelector('[data-shop-strip-static]'),
          button: group.querySelector('[data-shop-strip-toggle]'),
          links: group.querySelector('[data-shop-strip-links]')
        }));
        if (!this.groups.length) return;
        this.activeIndex = this.activeIndex ?? 0;
        this.media = window.matchMedia('(max-width: 700px)');
        this.onClick = event => {
          const button = event.target.closest('[data-shop-strip-toggle]');
          if (!button || !this.media.matches) return;
          const index = this.groups.findIndex(group => group.button === button);
          if (index < 0) return;
          this.activeIndex = index;
          this.update();
        };
        this.onResize = () => {
          const focused = this.groups.findIndex(group => group.group.contains(document.activeElement));
          if (this.media.matches && focused >= 0) this.activeIndex = focused;
          const focusedButton = this.groups.find(group => group.button === document.activeElement);
          this.update();
          if (!this.media.matches && focusedButton) focusedButton.links.querySelector('a')?.focus();
        };
        this.addEventListener('click', this.onClick);
        this.media.addEventListener('change', this.onResize);
        this.update();
      }
      update() {
        this.groups.forEach((group, index) => {
          const open = !this.media.matches || index === this.activeIndex;
          group.heading.hidden = this.media.matches;
          group.button.hidden = !this.media.matches;
          group.button.setAttribute('aria-expanded', String(open));
          group.button.querySelector('.rw-shop-strip__indicator').textContent = open ? '−' : '+';
          group.links.hidden = !open;
        });
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.media?.removeEventListener('change', this.onResize);
        this.media = null;
      }
    }
    customElements.define('rw-shop-strip', RunningWomanShopStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-shopify-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-shopify-reviews')) {
    customElements.define('rw-shopify-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) {
          window.addEventListener('hashchange', this.openLinkedForm);
          document.addEventListener('click', this.onFormLink);
          this.openLinkedForm();
          return;
        }
        const dataNode = this.querySelector('[data-native-review-data]');
        const labelNode = this.querySelector('[data-native-review-labels]');
        let data;
        try { data = JSON.parse(dataNode.textContent); this.labels = JSON.parse(labelNode.textContent); } catch { return; }
        const expected = { type: this.dataset.nativeResourceType, id: this.dataset.nativeResourceId };
        if (data.resource?.type !== expected.type || data.resource?.id !== expected.id) return;
        this.isArchive = expected.type === 'all' && this.hasAttribute('data-native-all-reviews') && /^[1-9]\d{0,19}$/.test(expected.id);
        const members = Array.isArray(data.groupMemberIds) ? data.groupMemberIds : [];
        const validGroup = expected.type === 'product' && members.length > 1 && members.length <= 1000 && members.includes(expected.id) && members.every(id => typeof id === 'string' && /^[1-9]\d{0,19}$/.test(id)) && new Set(members).size === members.length;
        const acceptedIds = new Set(validGroup ? members : [expected.id]);
        const seenIds = new Set();
        this.records = [...(Array.isArray(data.reviews) ? data.reviews : []), ...(Array.isArray(data.pages) ? data.pages.flatMap(page => Array.isArray(page) ? page : []) : [])]
          .filter(review => (this.isArchive ? ['product', 'article', 'page', 'company'].includes(review?.resource?.type) && /^[1-9]\d{0,19}$/.test(review.resource.id) && (review.resource.type !== 'company' || review.resource.id === expected.id) : review?.resource?.type === expected.type && acceptedIds.has(review.resource.id)) && Number.isInteger(review.rating) && review.rating >= 1 && review.rating <= 5)
          .filter(review => { if (seenIds.has(review.id)) return false; seenIds.add(review.id); return true; });
        if (this.isArchive && this.records.length !== data.count) {
          this.querySelector('[data-native-list]').replaceChildren();
          this.querySelector('.rw-native-reviews__summary')?.setAttribute('hidden', '');
          this.querySelector('[data-native-empty]').hidden = false;
          this.querySelector('[data-native-empty]').textContent = this.labels.unavailable;
          return;
        }
        this.list = this.querySelector('[data-native-list]');
        this.rating = this.querySelector('[data-native-rating-filter]');
        this.sort = this.querySelector('[data-native-sort]');
        this.photos = this.querySelector('[data-native-photos-filter]');
        this.more = this.querySelector('[data-native-more]');
        this.limit = 20;
        this.resourceFilter = '';
        this.ready = true;
        this.formAnchor = '#ReviewForm-' + expected.type + '-' + expected.id;
        this.openLinkedForm = () => {
          if (location.hash === this.formAnchor) {
            const form = this.querySelector('.rw-native-reviews__intake');
            if (form) form.open = true;
          }
        };
        this.onFormLink = event => {
          const link = event.target.closest('[data-product-first-review]');
          if (link?.hash === this.formAnchor) {
            const form = this.querySelector('.rw-native-reviews__intake');
            if (form) form.open = true;
          }
        };
        window.addEventListener('hashchange', this.openLinkedForm);
        document.addEventListener('click', this.onFormLink);
        this.openLinkedForm();
        this.querySelector('[data-native-filters]').hidden = this.records.length === 0;
        const types = this.querySelector('[data-native-types]');
        if (types) {
          types.hidden = this.records.length === 0;
          for (const button of types.querySelectorAll('[data-native-type]')) {
            const count = button.dataset.nativeType ? this.records.filter(review => review.resource.type === button.dataset.nativeType).length : this.records.length;
            button.querySelector('[data-native-type-count]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB').format(count);
            button.disabled = count === 0;
          }
        }
        this.addEventListener('change', () => { this.limit = 20; this.update(); });
        this.addEventListener('click', event => {
          const rating = event.target.closest('[data-native-rating]');
          if (rating) { this.rating.value = this.rating.value === rating.dataset.nativeRating ? '' : rating.dataset.nativeRating; this.limit = 20; this.update(); }
          const type = event.target.closest('[data-native-type]');
          if (type) { this.resourceFilter = type.dataset.nativeType; this.limit = 20; this.update(); }
          if (event.target.closest('[data-native-clear]')) { this.rating.value = ''; this.sort.value = 'newest'; this.photos.checked = false; this.resourceFilter = ''; this.limit = 20; this.update(); }
          if (event.target.closest('[data-native-more]')) { this.limit += 20; this.update(); }
          const imageLink = event.target.closest('[data-native-review-photo]');
          const dialog = this.querySelector('[data-native-photo-dialog]');
          if (imageLink && typeof dialog.showModal === 'function') {
            event.preventDefault();
            const fullPhoto = this.querySelector('[data-native-full-photo]');
            fullPhoto.src = imageLink.href;
            fullPhoto.alt = imageLink.querySelector('img').alt;
            dialog.showModal();
          }
          if (event.target.closest('[data-native-photo-close]')) dialog.close();
          const formLink = event.target.closest('.rw-native-reviews__cta');
          if (formLink) this.querySelector('.rw-native-reviews__intake').open = true;
        });
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('hashchange', this.openLinkedForm);
        document.removeEventListener('click', this.onFormLink);
      }
      text(tag, text, className) {
        const element = document.createElement(tag);
        element.textContent = text;
        if (className) element.className = className;
        return element;
      }
      card(review) {
        const card = this.text('article', '', 'rw-native-reviews__card');
        card.dataset.nativeReviewId = review.id;
        const header = this.text('header', '', 'rw-native-reviews__card-header');
        const author = document.createElement('div');
        author.append(this.text('strong', review.displayName));
        if (review.verifiedPurchase === true) author.append(this.text('span', this.labels.purchase, 'rw-native-reviews__verified'));
        else if (review.verifiedCustomer === true) author.append(this.text('span', this.labels.customer, 'rw-native-reviews__verified'));
        header.append(author);
        if (review.createdAt && Number.isFinite(Date.parse(review.createdAt))) {
          const date = this.text('time', new Intl.DateTimeFormat(document.documentElement.lang || 'en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(review.createdAt)));
          date.dateTime = review.createdAt;
          header.append(date);
        }
        card.append(header);
        const score = this.text('div', '', 'rw-native-reviews__card-rating');
        score.setAttribute('aria-label', this.labels.rating.replace('[rating]', review.rating));
        const stars = this.text('span', '', 'rw-review-stars');
        stars.setAttribute('aria-hidden', 'true');
        for (let value = 1; value <= 5; value++) stars.append(this.text('span', '\u2605', value <= review.rating ? 'is-filled' : ''));
        score.append(stars);
        card.append(score);
        if (this.isArchive) card.append(this.text('span', this.labels.types[review.resource.type], 'rw-native-reviews__kind'));
        if (review.resource?.type === 'product' && review.sourceProduct?.id === review.resource.id && typeof review.sourceProduct.title === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(review.sourceProduct.handle)) {
          const source = this.text('p', '', 'rw-native-reviews__source');
          const label = (this.labels.reviewedProduct || 'Reviewed: [product]').replace('[product]', review.sourceProduct.title);
          if (review.sourceProduct.published === true) {
            const link = this.text('a', label);
            link.href = `${this.dataset.nativeProductBase || '/products/'}${encodeURIComponent(review.sourceProduct.handle)}`;
            link.title = review.sourceProduct.title;
            source.append(link);
          } else source.textContent = label;
          card.append(source);
        }
        if (review.title) card.append(this.text('h3', review.title));
        card.append(this.text('p', review.body, 'rw-native-reviews__body'));
        const photos = this.text('div', '', 'rw-native-reviews__photos');
        for (const photo of Array.isArray(review.photos) ? review.photos.slice(0, 3) : []) {
          let url;
          try { url = new URL(photo.url); } catch { continue; }
          if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com' || !url.pathname.startsWith('/s/files/') || !/\.(?:jpe?g|png|webp|avif|gif)$/i.test(url.pathname) || url.username || url.password || url.port || url.hash) continue;
          const link = document.createElement('a');
          link.href = url.href; link.target = '_blank'; link.rel = 'noopener'; link.dataset.nativeReviewPhoto = ''; link.title = this.labels.photo.replace('[name]', review.displayName);
          const image = document.createElement('img');
          image.src = url.href; image.alt = photo.alt || link.title; image.width = photo.width; image.height = photo.height; image.loading = 'lazy';
          link.append(image); photos.append(link);
        }
        if (photos.children.length) card.append(photos);
        if (review.reply?.body) {
          const reply = this.text('div', '', 'rw-native-reviews__reply');
          reply.append(this.text('strong', this.labels.reply), this.text('p', review.reply.body, 'rw-native-reviews__body')); card.append(reply);
        }
        return card;
      }
      update() {
        const filtered = this.records.filter(review => (!this.resourceFilter || review.resource.type === this.resourceFilter) && (!this.rating.value || review.rating === Number(this.rating.value)) && (!this.photos.checked || review.photos?.length));
        filtered.sort((left, right) => (this.sort.value === 'highest' ? right.rating - left.rating : this.sort.value === 'lowest' ? left.rating - right.rating : 0) || (right.createdAt || '').localeCompare(left.createdAt || '') || right.id.localeCompare(left.id));
        const visible = filtered.slice(0, this.limit);
        this.list.replaceChildren(...visible.map(review => this.card(review)));
        this.more.hidden = visible.length >= filtered.length;
        const empty = this.querySelector('[data-native-empty]');
        empty.hidden = filtered.length > 0;
        empty.textContent = this.records.length ? this.labels.noMatches : this.labels.empty;
        this.querySelector('[data-native-results]').textContent = this.labels.results.replace('[shown]', visible.length).replace('[total]', filtered.length).replace('[reviews]', filtered.length === 1 ? this.labels.review : this.labels.reviews);
        this.querySelector('[data-native-clear]').hidden = !this.rating.value && !this.photos.checked && !this.resourceFilter && this.sort.value === 'newest';
        for (const button of this.querySelectorAll('[data-native-rating]')) button.setAttribute('aria-pressed', String(button.dataset.nativeRating === this.rating.value));
        for (const button of this.querySelectorAll('[data-native-type]')) button.setAttribute('aria-pressed', String(button.dataset.nativeType === this.resourceFilter));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-training-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-training-directory')) {
    customElements.define('rw-training-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('[data-plan-filters]');
        this.cards = Array.from(this.querySelectorAll('[data-plan-card]'));
        this.controls = Array.from(this.form.querySelectorAll('select'));
        this.count = this.querySelector('[data-plan-count]');
        this.countLabel = this.querySelector('[data-plan-count-label]');
        this.empty = this.querySelector('[data-plan-empty]');
        const params = new URLSearchParams(window.location.search);
        this.controls.forEach(control => {
          const value = params.get(control.name);
          if (Array.from(control.options).some(option => option.value === value)) control.value = value;
        });
        this.form.hidden = false;
        this.form.addEventListener('submit', event => { event.preventDefault(); this.filter(true); });
        this.form.addEventListener('change', () => this.filter(true));
        this.form.addEventListener('reset', event => {
          event.preventDefault();
          this.controls.forEach(control => { control.value = ''; });
          this.filter(true);
        });
        this.filter(false);
      }
      filter(updateUrl) {
        let count = 0;
        this.cards.forEach(card => {
          const visible = this.controls.every(control => !control.value || card.dataset[control.name] === control.value);
          card.hidden = !visible;
          if (visible) count += 1;
        });
        this.count.textContent = String(count);
        if (this.countLabel) this.countLabel.textContent = this.countLabel.dataset[count === 1 ? 'singular' : 'plural'];
        this.empty.hidden = count > 0;
        if (updateUrl) {
          const url = new URL(window.location.href);
          this.controls.forEach(control => {
            if (control.value) url.searchParams.set(control.name, control.value);
            else url.searchParams.delete(control.name);
          });
          window.history.replaceState(null, '', url);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-training-guides"]) return;
  try {
    
  document.querySelectorAll('[data-training-directory]').forEach(directory => {
    if (directory.dataset.directoryInitialized) return;
    directory.dataset.directoryInitialized = 'true';
    const search = directory.querySelector('[data-guide-search]');
    const input = search.querySelector('input');
    const clear = search.querySelector('[data-clear-search]');
    const groups = [...directory.querySelectorAll('[data-guide-group]')];
    const rows = [...directory.querySelectorAll('[data-guide-row]')];
    const count = directory.querySelector('[data-guide-count]');
    const empty = directory.querySelector('[data-guide-empty]');
    function update() {
      const query = input.value.trim().toLocaleLowerCase();
      let matches = 0;
      rows.forEach(row => { row.hidden = !row.dataset.guideSearchText.toLocaleLowerCase().includes(query); if (!row.hidden) matches += 1; });
      groups.forEach(group => { group.hidden = !group.querySelector('[data-guide-row]:not([hidden])'); });
      count.textContent = matches === 1 ? count.dataset.templateOne : count.dataset.template.replace('__COUNT__', matches);
      empty.hidden = matches !== 0;
      clear.hidden = input.value.length === 0;
    }
    search.hidden = false;
    input.addEventListener('input', update);
    clear.addEventListener('click', () => { input.value = ''; update(); input.focus(); });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
if (!customElements.get('rw-filtered-search')) {
  class RWFilteredSearch extends HTMLElement {
    static normalizePage(value) {
      if (typeof value !== 'string' && typeof value !== 'number') return 1;
      if (typeof value === 'string' && !/^\d+$/.test(value)) return 1;
      const page = Number(value);
      return Number.isSafeInteger(page) && page > 0 ? page : 1;
    }

    static paginateCards(cards, requestedPage, pageSize = 20) {
      if (!Array.isArray(cards) || !Number.isSafeInteger(pageSize) || pageSize < 1) {
        throw new Error('Invalid search pagination.');
      }
      const total = cards.length;
      const pages = Math.max(1, Math.ceil(total / pageSize));
      const page = Math.min(this.normalizePage(requestedPage), pages);
      return { cards: cards.slice((page - 1) * pageSize, page * pageSize), total, pages, page };
    }

    static validateBatch(batch, expectedPage, expectedPages, expectedCount) {
      const state = batch && batch.state;
      if (!state || !Array.isArray(batch.cards)
        || !Number.isSafeInteger(state.nativePage) || state.nativePage < 1
        || !Number.isSafeInteger(state.nativePages) || state.nativePages < 0 || state.nativePages > 20
        || !Number.isSafeInteger(state.nativeCount) || state.nativeCount < 0 || state.nativeCount > 1000
        || batch.cards.length > 50 || batch.cards.length > state.nativeCount
        || (state.nativePages === 0 && (state.nativeCount !== 0 || batch.cards.length !== 0))) {
        throw new Error('Invalid search batch.');
      }
      if ((expectedPage !== undefined && state.nativePage !== expectedPage)
        || (expectedPages !== undefined && state.nativePages !== expectedPages)
        || (expectedCount !== undefined && state.nativeCount !== expectedCount)) {
        throw new Error('Search results changed while loading.');
      }
      return batch;
    }

    static aggregateBatches(batches, nativePages) {
      if (!Array.isArray(batches) || !Number.isSafeInteger(nativePages) || nativePages < 0 || nativePages > 20) {
        throw new Error('Invalid search batches.');
      }
      const expectedLength = Math.max(1, nativePages);
      if (batches.length !== expectedLength) throw new Error('Missing search batch.');
      const ordered = new Map();
      const nativeCount = batches[0] && batches[0].state && batches[0].state.nativeCount;
      batches.forEach(batch => {
        this.validateBatch(batch, undefined, nativePages, nativeCount);
        const page = batch.state.nativePage;
        if (page > expectedLength || ordered.has(page)) throw new Error('Invalid search batch order.');
        ordered.set(page, batch.cards);
      });
      const cards = [];
      for (let page = 1; page <= expectedLength; page += 1) {
        if (!ordered.has(page)) throw new Error('Missing search batch.');
        cards.push(...ordered.get(page));
      }
      if (cards.length > nativeCount) throw new Error('Invalid search result count.');
      return cards;
    }

    static async collectBatches(initialBatch, loadBatch, options = {}) {
      this.validateBatch(initialBatch);
      const { nativePages, nativeCount, nativePage } = initialBatch.state;
      const checkAborted = () => {
        if (options.signal && options.signal.aborted) {
          const error = new Error('Search loading was cancelled.');
          error.name = 'AbortError';
          throw error;
        }
      };
      checkAborted();
      if (nativePages === 0) {
        return this.aggregateBatches([{ state: { nativePage: 1, nativePages, nativeCount }, cards: [] }], 0);
      }
      const batches = [];
      const pending = [];
      for (let page = 1; page <= nativePages; page += 1) {
        if (page === nativePage) batches.push(initialBatch);
        else pending.push(page);
      }
      let nextIndex = 0;
      let failed = false;
      const concurrency = Math.min(3, Math.max(1, Math.floor(Number(options.concurrency) || 3)));
      const worker = async () => {
        while (!failed && nextIndex < pending.length) {
          checkAborted();
          const page = pending[nextIndex++];
          try {
            const batch = await loadBatch(page);
            checkAborted();
            this.validateBatch(batch, page, nativePages, nativeCount);
            batches.push(batch);
          } catch (error) {
            failed = true;
            throw error;
          }
        }
      };
      await Promise.all(Array.from({ length: Math.min(concurrency, pending.length) }, worker));
      checkAborted();
      return this.aggregateBatches(batches, nativePages);
    }

    static queryKey(value) {
      const url = new URL(value);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      url.searchParams.sort();
      return `${url.origin}${url.pathname}?${url.searchParams.toString()}`;
    }

    static pageUrl(value, page) {
      const url = new URL(value);
      url.searchParams.delete('section_id');
      url.searchParams.set('page', String(this.normalizePage(page)));
      return url;
    }

    constructor() {
      super();
      this.generation = 0;
      this.onPaginationClick = this.onPaginationClick.bind(this);
      this.onHistoryChange = this.onHistoryChange.bind(this);
    }

    connectedCallback() {
      this.count = this.querySelector('[data-search-count]');
      this.list = this.querySelector('[data-search-list]');
      this.empty = this.querySelector('[data-search-empty]');
      this.pagination = this.querySelector('[data-search-pagination]');
      if (!this.count || !this.list || !this.empty || !this.pagination || !this.dataset.sectionId) return;
      if (!this.listening) {
        this.pagination.addEventListener('click', this.onPaginationClick);
        window.addEventListener('popstate', this.onHistoryChange);
        this.listening = true;
      }
      if (this.allCards !== undefined) {
        this.renderCurrentPage();
        return;
      }
      if (this.loading) return;
      this.loading = true;
      const generation = ++this.generation;
      const controller = new AbortController();
      this.controller = controller;
      this.requestUrl = new URL(window.location.href);
      this.requestKey = RWFilteredSearch.queryKey(this.requestUrl);
      if (this.fallbackCount === undefined) this.fallbackCount = this.count.textContent;
      this.count.textContent = this.dataset.loadingLabel || this.fallbackCount;
      this.setAttribute('aria-busy', 'true');
      const timeout = window.setTimeout(() => controller.abort(), 30000);
      this.loadResults(controller.signal)
        .then(cards => {
          if (!this.isConnected || this.generation !== generation) return;
          this.allCards = cards;
          this.renderCurrentPage();
        })
        .catch(() => {
          controller.abort();
          if (!this.isConnected || this.generation !== generation) return;
          this.count.textContent = [this.fallbackCount, this.dataset.errorLabel].filter(Boolean).join(' ');
        })
        .finally(() => {
          window.clearTimeout(timeout);
          if (this.generation !== generation) return;
          this.loading = false;
          this.controller = undefined;
          this.removeAttribute('aria-busy');
        });
    }

    disconnectedCallback() {
      this.generation += 1;
      if (this.controller) this.controller.abort();
      this.loading = false;
      this.removeAttribute('aria-busy');
      if (this.listening) {
        this.pagination.removeEventListener('click', this.onPaginationClick);
        window.removeEventListener('popstate', this.onHistoryChange);
        this.listening = false;
      }
    }

    readBatch(root) {
      const script = root.querySelector('script[data-search-state]');
      const list = root.querySelector('[data-search-list]');
      if (!script || !list) throw new Error('Missing search response.');
      const cards = Array.from(list.children);
      if (cards.some(card => !card.matches('.rw-search-result'))) throw new Error('Invalid search response.');
      return RWFilteredSearch.validateBatch({ state: JSON.parse(script.textContent), cards });
    }

    async loadResults(signal) {
      const initialBatch = this.readBatch(this);
      return RWFilteredSearch.collectBatches(initialBatch, async page => {
        const url = new URL(this.requestUrl);
        url.hash = '';
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('page', String(page));
        const response = await fetch(url.toString(), {
          signal,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Search request failed.');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const root = document.querySelector('rw-filtered-search') || document;
        return this.readBatch(root);
      }, { concurrency: 3, signal });
    }

    renderCurrentPage() {
      const url = new URL(window.location.href);
      if (RWFilteredSearch.queryKey(url) !== this.requestKey) {
        window.location.reload();
        return;
      }
      const requestedPage = url.searchParams.get('page');
      const configuredSize = Number(this.dataset.pageSize);
      const pageSize = Number.isSafeInteger(configuredSize) && configuredSize > 0 ? configuredSize : 20;
      const result = RWFilteredSearch.paginateCards(this.allCards, requestedPage, pageSize);
      if (requestedPage !== null && requestedPage !== String(result.page)) {
        window.history.replaceState(window.history.state, '', RWFilteredSearch.pageUrl(url, result.page));
      }
      this.list.replaceChildren(...result.cards);
      this.list.hidden = result.total === 0;
      this.empty.hidden = result.total !== 0;
      if (result.total === 0) this.empty.textContent = this.dataset.emptyLabel || '';
      this.count.textContent = (this.dataset.countTemplate || '__COUNT__').replace('__COUNT__', String(result.total));
      if (this.dataset.titleTemplate) {
        document.title = this.dataset.titleTemplate.replace('__COUNT__', String(result.total));
      }
      this.pagination.replaceChildren();
      this.pagination.hidden = result.pages <= 1;
      if (result.pages <= 1) return;
      const addLink = (page, label, relation) => {
        const link = document.createElement('a');
        link.href = RWFilteredSearch.pageUrl(window.location.href, page).toString();
        link.dataset.searchPage = String(page);
        link.textContent = label;
        link.rel = relation;
        this.pagination.append(link);
      };
      if (result.page > 1) addLink(result.page - 1, this.dataset.previousLabel, 'prev');
      const current = document.createElement('span');
      current.className = 'page current';
      current.setAttribute('aria-current', 'page');
      current.textContent = `${result.page} / ${result.pages}`;
      this.pagination.append(current);
      if (result.page < result.pages) addLink(result.page + 1, this.dataset.nextLabel, 'next');
    }

    onPaginationClick(event) {
      if (this.allCards === undefined || event.defaultPrevented || event.button !== 0
        || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[data-search-page]');
      if (!link || !this.pagination.contains(link)) return;
      event.preventDefault();
      window.history.pushState(window.history.state, '', link.href);
      this.renderCurrentPage();
      this.scrollIntoView({ block: 'start' });
    }

    onHistoryChange() {
      if (this.allCards !== undefined) this.renderCurrentPage();
    }
  }
  customElements.define('rw-filtered-search', RWFilteredSearch);
}


  } catch(e) { console.error(e); }
})();
})();
